// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_c5-0";